<template>
  <v-container
      fluid="true"
      fill-height="true"
  >
    <v-layout
        justify-center="true"
        align-center="true"
    >
      <v-row>
        <v-col>
          <v-list v-if="isLoading">
            <invoice-list-item-skeleton
                v-for="index in skeletonAmount"
                :key="index"
            />
          </v-list>
          <v-list v-else>
            <p
                v-if="isLoading === false && items.length === 0"
                class="text-h6 text-center"
            >
              Invoices not found
            </p>
            <invoice-list-item
                v-for="(item, index) in items"
                :key="item"
                :id="item.id"
                :index="index"
                :title="item.title"
                :created-at="item.createdAt"
                :size="item.size"
                @download-invoice="passThroughDownloadInvoice"
            />
          </v-list>
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
import InvoiceListItemSkeleton from "@/components/Invoice/InvoiceListItemSkeleton.vue";
import InvoiceListItem from "@/components/Invoice/InvoiceListItem.vue";

export default {
  name: "InvoiceList",
  components: {InvoiceListItem, InvoiceListItemSkeleton},
  emits: ['downloadInvoice'],
  props: {
    isLoading: Boolean,
    items: Array,
    skeletonAmount: Number
  },
  methods: {
    passThroughDownloadInvoice(id) {
      this.$emit('downloadInvoice', id)
    }
  }
}
</script>

<style scoped>

</style>